<template>
  <CompanySealsContext>
    <RouterView></RouterView>
  </CompanySealsContext>
</template>

<script setup lang="ts">
import CompanySealsContext from '@/components/deepSign/sealSettings/seals/CompanySealsContext.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepsign.seal_settings',
  },
})
</script>
